import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-hjp-confirm-modal" }
const _hoisted_2 = { class: "header flex" }
const _hoisted_3 = { class: "content mb-4" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "my-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-base font-semibold" }, "Arahkan scanner atau kamera Anda ke QR Code Voucher untuk melakukan verifikasi kupon BBM.")
], -1)
const _hoisted_6 = { class: "flex items-center justify-end mt-6" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Kembali")

import Dialog from 'primevue/dialog'
import QrScanner from '@/views/shared-components/QrScanner.vue'
import { PropType, computed, ref } from 'vue'
import Button from 'primevue/button'


export default /*#__PURE__*/_defineComponent({
  __name: 'ApproveCoupon',
  props: {
  isShowDialog: {
    type: Boolean,
    default: false
  }
},
  emits: ["hideDialog", "onDetect"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
  (e: 'onDetect', data: any): void

}), expose: any, slots: any, attrs: any }) {

const props = __props



const showDialog = ref(props.isShowDialog)

const onDetectScanner = (data: any) => {
  console.log('data', data)
  emit('onDetect', data)
  // eslint-disable-next-line no-use-before-define
  // hideDialog()
}

const hideDialog = () => {
  // dialogDetailResi.value = false
  showDialog.value = false
  emit('hideDialog')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Dialog), {
      showHeader: false,
      visible: showDialog.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' },
      modal: true,
      contentClass: "wrap-content-hjp-confirm-modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "pi pi-times cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideDialog()))
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (showDialog.value)
              ? (_openBlock(), _createBlock(QrScanner, {
                  key: 0,
                  style: {"width":"100%"},
                  onOnDetect: onDetectScanner
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Button), {
              class: "btn-back mr-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (hideDialog()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})